import React from 'react'

import { signInUsingSaml } from 'components/authentication/authentication-utils'
import { LowerLink } from 'components/authentication/LowerLink'
import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import { UpperBackText } from 'components/authentication/UpperBackText'
import Button from 'components/common/Button'
import InputTextField from 'components/common/InputTextField'
import useAppRefresh from 'hooks/use-app-refresh'

export const SignInUsingSAML: React.FC = () => {
  const appRefresh = useAppRefresh()
  const [companyName, setCompanyName] = React.useState('')

  return (
    <SignedOutFormContainer>
      <UpperBackText to="/login">Back to login</UpperBackText>
      <SignedOutForm
        title="Sign in using SAML"
        onSubmit={(event) => {
          event.preventDefault()
          signInUsingSaml(appRefresh, companyName)
        }}
      >
        <InputTextField
          data-test-signin-using-saml-company-name
          focusOnMount={true}
          label="Company Name"
          value={companyName}
          onChange={(event) => setCompanyName(event.target.value)}
        />
        <Button
          data-test-signin-using-saml-continue-button
          stretch
          disabled={!companyName}
          label="Continue"
          type="submit"
        />
      </SignedOutForm>
      <LowerLink to="/find/company">Forgot Company?</LowerLink>
    </SignedOutFormContainer>
  )
}
